import React from 'react'
import abimg from '../../images/home/homeImage2.png'
// import VideoModal from '../ModalVideo'
import './style.css'

const AboutExtended = (props) => {
  return (
    <div className="wpo-about-area section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 colsm-12">
            <div className="wpo-about-text">
              <div className="wpo-section-title">
                {/* <span>What We Do?</span> */}
                <h2>About Us</h2>
              </div>
              <p>Nirbaak is a vibrant social and cultural organization dedicated to the timeless art of mime—the powerful language of silence and expression. Since its inception in 2018, Nirbaak has been passionately committed to using this unique art form to communicate stories, emotions, and critical social messages without words.</p>
              <p>Through evocative street performances and theatrical shows, Nirbaak brings to life pressing social issues such as AIDS, COVID-19, cancer, cybercrime, child marriage, environmental conservation, road safety, and drug abuse. Their performances transcend language barriers, touching hearts and inspiring awareness and change in communities.</p>
              <p>In collaboration with government departments, Nirbaak has pioneered initiatives like the inaugural celebration of World Mime Day in Assam, amplifying the reach and impact of mime. The organization also proudly publishes Nirbaak, India's first international journal devoted exclusively to mime, fostering dialogue and appreciation for this silent art worldwide.</p>
              <p>At the forefront of Nirbaak's creative journey is Minangka Deka, an acclaimed mime artist recognized for his dedication and artistry. His accolades include the Senior Scholarship for Mime from the Ministry of Culture, Government of India, and the prestigious Young Talented Artist Award from NEZCC.</p>
              <p>Through the art of mime, Nirbaak transforms silence into a compelling voice for social change—reminding us that sometimes, the most profound messages are those spoken without words.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 colsm-12">
            <div className="wpo-about-img-3">
              <img src={abimg} alt="" />
            </div>
          </div>
        </div>
      </div>
      
    </div>

    
  )
}

export default AboutExtended;